import logoDark from '@assets/images/co2ai-logo.png'
import logoLight from '@assets/images/co2ai-logo-light.png'
import { useThemeMode } from '@contexts/ThemeContext'

const useLogo = () => {
	const { mode } = useThemeMode()
	return mode === 'light' ? logoLight : logoDark
}

export { useLogo }
